import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { compose } from "redux";

import * as nextReducer from "containers/Next/NextReducer";
import * as viewReducer from "containers/View/reducer";
import * as homeReducer from "containers/Home/reducer";
import * as chatGPTReducer from "containers/ChatGPT/reducer";

import Dashboard from "components/Next/Dashboard/Dashboard";

const getId = (props) =>
  props && props.id
    ? props.id
    : props && props.match && props.match.params && props.match.params.id
      ? props.match.params.id
      : "new";

const getDatasetId = (props) =>
  props && props.datasetId
    ? props.datasetId
    : props && props.match && props.match.params && props.match.params.datasetId
      ? props.match.params.datasetId
      : "new";

class DashboardContainer extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return <Dashboard {...this.props} />;
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  const id = getId(ownProps);
  const datasetId = getDatasetId(ownProps);

  return {
    updateHideLine: (hideValue, isHidden) => dispatch(nextReducer.updateHideLine(id, hideValue, isHidden)),
    updateHideLines: (hideLines) => dispatch(nextReducer.updateHideLines(id, hideLines)),
    updateDashboardChartOptions: (dashboardChartOptions) =>
      dispatch(nextReducer.updateDashboardChartOptions(id, dashboardChartOptions)),
    removeOrAddNode: (node) => dispatch(nextReducer.removeOrAddNode(id, node)),
    updateSearchDashboard: (search) => dispatch(nextReducer.updateSearchDashboard(id, search)),
    updateSearchDashboardSimple: (search) => dispatch(nextReducer.updateSearchDashboardSimple(id, search)),
    quickSearch: (column) => dispatch(nextReducer.quickSearch(id, column)),

    exportToLooker: () => dispatch(nextReducer.exportToLooker(id)),
    updateIgnoreInfoChartField: (ignoreInfoChartField) =>
      dispatch(nextReducer.updateIgnoreInfoChartField(id, ignoreInfoChartField))
  };
};
const mapStateToProps = (state, ownProps) => {
  const id = getId(ownProps);
  const datasetId = getDatasetId(ownProps);
  const projectId = nextReducer.getProjectId(state, id);

  // This needs getEmptyInfographicDashboard to be rewritten as a dispatch
  //const emptyOpts = nextReducer.getEmptyInfographicDashboard(state, id);
  const searchOpts = nextReducer.getSearchOptions(state, id);

  return {
    id: id,
    datasetId: datasetId,
    projectId: projectId,

    dataset: homeReducer.getDataset(state, datasetId),

    chart: nextReducer.getDashboardChart(state, id),
    allCharts: nextReducer.getAllDashboardCharts(state, id),
    muscleMatrix: nextReducer.getMuscleMatrix(state, id),

    searchCharts: nextReducer.getSearchDashboardChart(state, id),

    searchOpts: searchOpts,

    ignoreInfoChartField: nextReducer.getIgnoreInfoChartField(state, id),

    isHideLegend: nextReducer.getIsHideLegend(state, id),
    isAngleAxis: nextReducer.getIsAngleAxis(state, id),
    dashboardSize: nextReducer.getDashboardSize(state, id),

    isDomainMin: nextReducer.getIsDomainMin(state, id),

    hideLines: nextReducer.getHideLines(state, id),
    dashboardChartOptions: nextReducer.getDashboardChartOptions(state, id),
    dashboardLayout: nextReducer.getDashboardLayout(state, id)
  };
};

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect, withRouter)(DashboardContainer);
